// Wire types for `tktuner sync` -> POST /v1/sync. Pure type declarations —
// the CLI produces them (after the privacy transform) and the API validates
// them with zod server-side. The privacy invariant lives here: no cwd, no
// gitBranch, no filePath, and never any message/tool content.
import type { TokenUsage } from "./types";

export const SYNC_MAX_TURNS_PER_BATCH = 2000;
export const SYNC_MAX_EVENTS_PER_BATCH = 5000;

export interface SyncTurnWire {
  /** coalesce(messageId, uuid) — the server's idempotent upsert key. */
  turnKey: string;
  uuid: string;
  messageId?: string;
  requestId?: string;
  sessionId: string;
  agentId?: string;
  parentSessionId?: string;
  isSidechain: boolean;
  /** sha256(cwd) truncated to 16 hex chars. */
  projectId: string;
  /** basename(cwd). */
  projectName: string;
  slug?: string;
  /** Epoch ms. */
  ts: number;
  model: string;
  usage: TokenUsage;
  tools: string[];
  numToolUses: number;
  thinkingChars: number;
  textChars: number;
  stopReason?: string;
  /** Claude Code version that wrote the log line. */
  version?: string;
  speed?: string;
  inferenceGeo?: string;
}

export interface SyncEventWire {
  /** Local sqlite autoincrement id (traceability only — dedup is content-based). */
  localEventId: number;
  sessionId: string;
  ts?: number;
  kind: string;
  data: Record<string, unknown>;
}

export interface SyncPushBody {
  turns: SyncTurnWire[];
  events: SyncEventWire[];
  cliVersion?: string;
}

export interface SyncPushResult {
  turnsUpserted: number;
  eventsInserted: number;
}
